<script setup lang="ts">

defineOptions({
  name: 'TextPrimaryMedium'
})

interface TextPrimaryMediumProps {
  is?: 'div' | 'p' | 'span'
}
withDefaults(defineProps<TextPrimaryMediumProps>(), {
  is: 'div'
})
</script>

<template>
  <component
    :is="is"
    class="p-text-primary"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="@scss/components/UI/Typography/TextPrimary.scss" />
